import enviro from 'enviro';
export const getPlayerEnv = () => enviro.getShort('video_player');
export const getFormsEmbedEnv = () => enviro.getShort('forms_embed');
export function getMuxEnvKey() {
  return enviro.ifHublet({
    isNa1: () => enviro.isQa() ? 'q9om0msnh4pkbbusrg9i95j8u' : 'bbh9mqlh0bi8si8rd8kc86qf7',
    isNonNa1: () => enviro.isQa() ? 'cl2ljlrmq4j4ot7ok41ubji48' : 'dld0a7bdnsnh2eqrj4q756877'
  });
}
export function isBrowseriOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform);
}